import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { font, colors } from '@chegg-ui/theme';
import { SVGStyled } from '../shared';

/**
 * Base SVG Text component
 *
 * @param props.fontSize number (equivalent to pixels), *scales relative to SVG dimensions*
 * @param props.fontWeight theme font.weight value
 * @param props.svgColor fill color (if not set, relies on value from context)
 */
var SVGText = SVGStyled.text(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  fill: ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n"])), colors.white, function (_ref) {
  var svgColor = _ref.svgColor,
      theme = _ref.theme;
  return svgColor || theme.svgColor;
}, function (_ref2) {
  var fontSize = _ref2.fontSize;
  return fontSize || 16;
}, function (_ref3) {
  var fontFamily = _ref3.fontFamily;
  return fontFamily || font.family["default"];
}, function (_ref4) {
  var fontWeight = _ref4.fontWeight;
  return fontWeight || font.weight.normal;
}, function (_ref5) {
  var lineHeight = _ref5.lineHeight;
  return lineHeight ? "line-height: ".concat(lineHeight, ";") : '';
});
export default SVGText;